export function truncate(string: string, length = 10) {
  if (string.length <= length) {
    return string;
  }
  return `${string.substring(0, length)} ...`;
}

export function parametrize(string: string){
  const splitedString = string.split('.');
  splitedString.pop();
  const joinedString = splitedString.join('-');
  return joinedString.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, "").replace(/\s/g, "-");
}

export function generateRandomFileName(originalFileName: string){
  const ext = originalFileName.split('.').pop();
  return `${new Date().getTime()}.${ext}`
}